import Api from '../Api';

import { url } from './config';
import { PriceComponent } from './types';

const api = new Api<PriceComponent>(url);

export default api;
